/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobFromDateQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TemplateJobFromDateQueryOperator");
    }

    getFixupPrototypeFunction() { return TemplateJobFromDateQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobFromDateQueryOperator>): TemplateJobFromDateQueryOperator {
        let obj = Object.assign(new TemplateJobFromDateQueryOperator(), model);
        TemplateJobFromDateQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobFromDateQueryOperator>): TemplateJobFromDateQueryOperator {
        if (!model) return null;
        return TemplateJobFromDateQueryOperator.newInstance(<TemplateJobFromDateQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobFromDateQueryOperator) {
        if (!obj) return;

        models.TemplateJobFromDateQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobFromDateQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobFromDateQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.from_date === "string") {
            this.from_date = new Date(<string><any>this.from_date);
        }
    }

    /**
     * Include jobs created on or after this date
     */
    from_date: Date;

}
